import { fetchingProduct } from "../../helpers/fetchingProduct";
import { templateWishlist } from "../../helpers/template/templateWishlist";

const LOCAL_STORAGE_WISHLIST_KEY = "wishlist-regool";
const LOCAL_STORAGE_DELIMITER = ",";
const BUTTON_ACTIVE_CLASS = "active";

const WishlistStorage = {
  storage: window.localStorage,
  key: LOCAL_STORAGE_WISHLIST_KEY,
  delimiter: LOCAL_STORAGE_DELIMITER,

  set() {
    if (!this.storage.getItem(this.key)) {
      this.storage.setItem(this.key, "");
    }
  },

  get() {
    this.set();
    const items = this.storage.getItem(this.key);
    return items ? items.split(this.delimiter) : [];
  },

  add(id) {
    const items = this.get();
    if (!items.includes(id)) {
      items.push(id);
      this.storage.setItem(this.key, items.join(this.delimiter));
    }
  },

  remove(handle) {
    const items = this.get();
    const filteredItems = items.filter((item) => item !== handle);
    this.storage.setItem(this.key, filteredItems.join(this.delimiter));
  },

  clear() {
    this.storage.removeItem(this.key);
  },
};

WishlistStorage.set();

const selectors = {
  buttons: document.querySelectorAll("[button-wishlist]"),
  wishlist: document.querySelector("[grid-wishlist]"),
  loader: document.querySelector("[loader-wishlist]"),
  bottomWishlist: document.querySelector(".wishlist-container__bottom"),
  clearWishlist: document.querySelector(".wishlist-container__clear-wishlist"),
};
selectors.buttons.forEach((button) => {
  button.addEventListener("click", (event) => {
    const productHandle = button.dataset.productHandle;
    button.classList.toggle(BUTTON_ACTIVE_CLASS);

    if (button.classList.contains(BUTTON_ACTIVE_CLASS)) {
      WishlistStorage.add(productHandle);
    } else {
      WishlistStorage.remove(productHandle);
    }
  });
});
selectors.clearWishlist.addEventListener("click", () => {
  WishlistStorage.clear();
  selectors.wishlist.innerHTML = "";
  selectors.bottomWishlist.style.display = "none";
  selectors.loader.style.display = "none";
  selectors.wishlist.innerHTML =
    "<h3 class='wishlist-container__h3 h3'>No tienes productos en tu wishlist</h3>";
  initButtons();
});

initButtons();
export function initButtons() {
  const products = WishlistStorage.get();
  selectors.buttons.forEach((button) => {
    button.classList.remove(BUTTON_ACTIVE_CLASS);
  });
  selectors.buttons.forEach((button) => {
    if (products.includes(button.dataset.productHandle)) {
      button.classList.add(BUTTON_ACTIVE_CLASS);
    }
  });
}
export function chargerProductsInWishlist() {
  if (!selectors.wishlist) return;
  selectors.wishlist.innerHTML = "";
  let fullProducts = WishlistStorage.get();

  if (fullProducts.length === 0) {
    selectors.bottomWishlist.style.display = "none";
    selectors.loader.style.display = "none";
    selectors.wishlist.innerHTML =
      "<h3 class='wishlist-container__h3 h3'>No tienes productos en tu wishlist</h3>";
    return;
  } else {
    selectors.bottomWishlist.style.display = "block";
    selectors.loader.style.display = "block";
    fullProducts.forEach((product) => {
      fetch(window.Shopify.routes.root + `products/${product}.js`)
        .then((response) => response.json())
        .then((product) => {
          selectors.loader.style.display = "none";
          selectors.wishlist.innerHTML += templateWishlist(product);
          const addCartWishlist = document.querySelectorAll(
            ".article-wishlist__add-to-cart"
          );
          const deleteFromWishlist = document.querySelectorAll(
            ".article-wishlist__delete"
          );

          deleteFromWishlist.forEach((deleteButton) => {
            deleteButton.addEventListener("click", (event) => {
              const productHandle = deleteButton.dataset.productHandle;
              WishlistStorage.remove(productHandle);
              deleteButton.closest(".article-wishlist").remove();
              initButtons();
            });
          });
          addCartWishlist.forEach((prod) => {
            prod.addEventListener("click", async (event) => {
              const loader = prod.querySelector(
                ".product-article__action--loader"
              );
              loader.style.display = "block";
              const productId = prod.dataset.productId;
              fetchingProduct("/cart/add.js", "POST", "id", productId, 1)
                .then(() => {
                  productAdded(product);
                  loader.style.display = "none";
                })
                .catch((error) => {
                  console.error("Error al añadir producto:", error.message);
                  loader.style.display = "none";
                });
            });
          });
        });
    });
  }
}
